<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import userPower from "@/mixin/userPower";

export default {
  mixins: [userPower],
  components: {
    pageTemplate,
  },
  data() {
    return {
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "门店订单号",
            type: "input",
            prop: "orderNo",
            isFuzzy: true,
            placeholder: "请输入门店订单号"
          },

        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 12,
            url: api.system.seStore,
          },
          {
            label: "取消原因来源",
            prop: "cancelFrom",
            width: "150",
            type: 'select',
            span: 12,
            data: this.$utils.getCacheStatus('deDaOrder.cancelFrom'),
          },
          {
            label: "订单类型",
            prop: "orderGenre",
            width: "120",
            type: 'select',
            span: 12,
            data: this.$utils.getCacheStatus('deDaOrder.orderGenre'),
          },
          {
            label: "订单状态",
            prop: "status",
            width: "120",
            type: 'select',
            span: 12,
            data: this.$utils.getCacheStatus('deDaOrder.status'),
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: "新增",
          code: "insert",
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "编辑",
          code: "update",
          type: this.$utils.buttonType.tableOperate,
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {label: "门店名称", prop: "storeName", width: "120", align: "center",},
          {label: "门店订单号", prop: "orderNo", width: "120", align: "center"},
          {label: "达达订单号", prop: "clientId", width: "150", align: "center",},
          {
            label: "取消原因来源",
            prop: "cancelReason",
            width: "150",
            align: "center",
            enumData: this.$utils.getCacheStatus('deDaOrder.cancelFrom'),
          },
          {label: "配送员姓名", prop: "dmName", width: "120", align: "center",},
          {label: "配送员手机号", prop: "dmMobile", width: "240", align: "center",},
          {label: "提取码", prop: "finishCode", width: "120", align: "center",},
          {label: "违约金", prop: "deductFee", width: "120", align: "center",},
          {
            label: "订单类型",
            prop: "orderFenre",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('deDaOrder.orderGenre'),
          },
          {label: "配送距离", prop: "distance", width: "120", align: "center",},
          {label: "实际配送费", prop: "fee", width: "120", align: "center", precision: 2},
          {label: "配送费", prop: "deliverFee", width: "120", align: "center",},
          {
            label: "订单状态",
            prop: "status",
            width: "120",
            align: "center",
            enumData: this.$utils.getCacheStatus('deDaOrder.status'),
          },
          {label: "操作时间", prop: "last_modify_dttm", width: "120", align: "center",},
          {label: "备注", prop: "remarks", width: "120", align: "center",},
        ],
        url: api.distribution.ddDistributionRecord,
      },
    };
  },
  created() {
    this.setStore(this.searchOptions.simple);
  },
  methods: {
    //商户门店

  },
};
</script>




// WEBPACK FOOTER //
// src/page/delivery/dd/Record.vue